import { Link } from 'react-router-dom';
import {
  Rocket,
  Users,
  Calendar,
  MapPin,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import type { HelpCategoryMeta } from '../../types/help';

const iconMap: Record<string, LucideIcon> = {
  Rocket,
  Users,
  Calendar,
  MapPin,
  Settings,
};

interface HelpCategoryCardProps {
  category: HelpCategoryMeta;
  articleCount: number;
}

export default function HelpCategoryCard({
  category,
  articleCount,
}: HelpCategoryCardProps) {
  const Icon = iconMap[category.icon] || Rocket;

  return (
    <Link
      to={`/help/${category.slug}`}
      className="block rounded-lg border p-5 transition-all hover:border-[var(--oro-gold)]"
      style={{
        backgroundColor: 'var(--oro-surface)',
        borderColor: 'var(--oro-border)',
      }}
    >
      <div className="flex items-start gap-4">
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
          style={{ backgroundColor: 'var(--oro-surface-alt)' }}
        >
          <Icon className="h-5 w-5" style={{ color: 'var(--oro-gold)' }} />
        </div>
        <div className="min-w-0 flex-1">
          <h3
            className="text-lg font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            {category.title}
          </h3>
          <p
            className="mt-1 text-sm leading-relaxed"
            style={{ color: 'var(--text-secondary)' }}
          >
            {category.description}
          </p>
          <p
            className="mt-2 text-xs font-medium"
            style={{ color: 'var(--text-muted)' }}
          >
            {articleCount} {articleCount === 1 ? 'article' : 'articles'}
          </p>
        </div>
      </div>
    </Link>
  );
}
